import deepmerge from "@node/deepmerge";

let locales = {};
const modules = import.meta.glob("@o-din-lk/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-lk/src/store_lk"

export default {
  routes: [
    { path: '/lk/posts', component: () => import("./views/lk/posts/Index.vue") },
    { path: '/lk/posts/new', component: () => import("./views/lk/posts/Form.vue") },
    { path: '/lk/posts/:id/edit', component: () => import("./views/lk/posts/Form.vue") },
    { path: '/lk/posts/:id', component: () => import("./views/lk/posts/Show.vue") },
    { path: '/lk/documents', component: () => import("./views/lk/documents/Index.vue") },
    { path: '/lk/documents/new', component: () => import("./views/lk/documents/Form.vue") },
    { path: '/lk/documents/:id/edit', component: () => import("./views/lk/documents/Form.vue") },
    { path: '/lk/surveys', component: () => import("./views/lk/surveys/Index.vue") },
    { path: '/lk/surveys/new', component: () => import("./views/lk/surveys/Form.vue") },
    { path: '/lk/surveys/:id/edit', component: () => import("./views/lk/surveys/Form.vue") },
    { path: '/lk/surveys/:id', component: () => import("./views/lk/surveys/Show.vue") },
    { path: '/lk/survey_results/:id/edit', component: () => import("./views/lk/survey_results/Form.vue") }
  ],
  locales,
  store
}
